var t = { exports: {} };
export {
  t as __module
};
